<template>
  <div>
    <sweet-modal ref="faqModal" overlay-theme="dark" :hideCloseButton="false">
      <div class="row">
        <div class="col-md-12 p-2 bg-gray">
          <h3>Public Liability Insurance Online Quote</h3>
          <p>
            We understand that there is more to business insurance than just
            public liability.
          </p>
          <p>
            Our system allows you to request quotes on a range of policies
            including public liability, professional indemnity, income
            protection and all other forms of business insurance.
          </p>
          <p>
            Instead of having to complete multiple forms for each different type
            of insurance, we can provide you with quotes on a range of cover
            types using our simple online form.
          </p>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SweetModal } from "sweet-modal-vue";

export default {
  components: {
    SweetModal,
  },
  computed: {
    ...mapState({
      showFaq: (state) => state.showFaq,
    }),
  },
  methods: {
    resetModal: function () {
      this.$store.commit("setFaq", { showFaq: false });
    },
  },
};
</script>
